<template>
  <!-- 图书资源管理 -->
  <div class="layout">
    <div class="menu">
      <Menu topIndex="dbWork"></Menu>
    </div>
    <div class="leftSide">
      <LeftSideBar current="dbWork" leftIndex="qaManage"></LeftSideBar>
    </div>
    <div id="sortContent">
      <div class="left-tree">
        <el-input
          class="subject-search-input"
          placeholder="请输入名称"
          v-model="treeSearchContent"
        ></el-input>
        <el-tree
          ref="tree"
          v-if="opentree"
          :props="props"
          :load="loadNode"
          icon-class="el-icon-folder"
          highlight-current
          :expand-on-click-node="false"
          node-key="id"
          @node-click="listClick"
          :filter-node-method="treeSearch"
          lazy
        >
        </el-tree>
      </div>
      <div class="rightBox">
        <!-- 上方按钮 -->
        <div class="button-box">
          <!-- <el-button type="text" icon="el-icon-document-copy" size="small"
            >批量标引</el-button
          > -->
           <el-button
            type="text"
            icon="el-icon-delete"
            size="small"
            @click="preCheck('toDelete')"
            :disabled="this.listInnerCode == ''"
            >删除</el-button
          >
          <el-button
            type="text"
            icon="el-icon-bottom"
            size="small"
            @click="preCheck('toDown')"
            :disabled="this.listInnerCode == ''"
            >下架</el-button
          >
          <el-button
            type="text"
            icon="el-icon-top"
            size="small"
            @click="preCheck('toUP')"
            :disabled="this.listInnerCode == ''"
            >上架</el-button
          >
          <!-- <el-button
            type="text"
            icon="el-icon-download"
            size="small"
            @click="SourceOut()"
            >资源出库</el-button
          > -->
          <!-- <el-button
            type="text"
            icon="el-icon-tickets"
            size="small"
            @click="listOut()"
            >按条目表出库</el-button
          > -->
          <!-- <el-button
            type="text"
            icon="el-icon-document-checked"
            size="small"
            @click="specialOut()"
            >专项内容出库</el-button
          > -->
          <!-- <el-button
            type="text"
            icon="el-icon-upload2"
            size="small"
            @click="reorderPre()"
            >导出列表</el-button
          > -->
          <!-- <el-button
            type="text"
            icon="el-icon-c-scale-to-original"
            size="small"
            @click="sourceCompare()"
            >资源对比</el-button
          > -->
        </div>
        <!-- 上方按钮end -->
        <div class="contentBox">
          <div id="searchBox">
            <el-form
              label-width="90px"
              ref="searchFileForm"
              :model="searchFileForm"
            >
              <el-form-item label="资源名称">
                <el-input
                  v-model="searchFileForm.name"
                  placeholder="请输入资源名称"
                ></el-input>
              </el-form-item>
              <!-- <el-form-item label="全文检索">
                <el-input placeholder="请输入全文检索"></el-input>
              </el-form-item> -->
              <!-- <el-form-item label="所属图书">
                <el-input placeholder="请输入所属图书"></el-input>
              </el-form-item> -->
              <el-form-item label="来源">
                <el-select
                  placeholder="请选择来源"
                  v-model="searchFileForm.sourceId"
                  clearable
                >
                  <el-option
                    v-for="item in sourceList"
                    :key="item.id"
                    :value="item.id"
                    :label="item.name"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="资源状态">
                <el-select v-model="searchFileForm.status" clearable>
                  <el-option value="10" label="下架"> </el-option>
                  <el-option value="20" label="上架"> </el-option>
                </el-select>
              </el-form-item>
              <!-- <el-form-item label="标引状态">
                <el-select placeholder="请选择来源">
                  <el-option> </el-option>
                </el-select>
              </el-form-item> -->
              <!-- <el-form-item label="标引标签">
                <el-select placeholder="请选择来源">
                  <el-option> </el-option>
                </el-select>
              </el-form-item> -->
              <el-form-item label-width="0px">
                <el-button
                  type="primary"
                  size="mini"
                  icon="el-icon-search"
                  @click="
                    currentPage = 1;
                    onSearch();
                  "
                  >查询</el-button
                >
              </el-form-item>
            </el-form>
          </div>
          <div>
            <div class="tip-text" v-if="this.listInnerCode == ''">
              请选择资源库
            </div>
            <!-- 主列表 -->
            <div v-if="this.listInnerCode != ''">
              <el-table
                :data="bkTableData"
                element-loading-text="拼命加载中"
                element-loading-spinner="el-icon-loading"
                style="width: 100%"
                class="maintable"
                border
                :header-cell-style="{ background: '#f8f8f8' }"
                @selection-change="handleTableSelectionChange"
              >
                <el-table-column
                  type="selection"
                  min-width="55"
                  align="center"
                ></el-table-column>
                <el-table-column type="index" min-width="50" align="center">
                </el-table-column>
                <el-table-column
                  prop="name"
                  show-overflow-tooltip
                  min-width="80"
                  label="资源标题"
                  align="center"
                ></el-table-column>
                <el-table-column
                  prop="subjectInfo.subBranch"
                  min-width="80"
                  label="分支"
                  align="center"
                >
                </el-table-column>
                <el-table-column
                  prop="keywords"
                  min-width="80"
                  label="关键字"
                  align="center"
                >
                </el-table-column>
                <el-table-column
                  prop="status"
                  show-overflow-tooltip
                  label="状态"
                  min-width="70px"
                  align="center"
                >
                  <template slot-scope="scope">
                    <span effect="dark" v-if="scope.row.status == 20"
                      >已上架</span
                    >
                    <span effect="dark" v-if="scope.row.status == 10"
                      >未上架</span
                    >
                  </template>
                </el-table-column>
                <el-table-column
                  prop="sourceInfo.name"
                  show-overflow-tooltip
                  label="来源"
                  min-width="70px"
                  align="center"
                >
                </el-table-column>
                
                <el-table-column
                  prop="isRemove"
                  show-overflow-tooltip
                  label="是否已被删除"
                  min-width="70px"
                  align="center"
                >
                  <template slot-scope="scope">
                    <span
                      effect="dark"
                      v-if="
                        scope.row.isRemove == 10 || scope.row.isRemove == null
                      "
                      >否</span
                    >
                    <span effect="dark" v-if="scope.row.isRemove == 20"
                      >是</span
                    >
                  </template>
                </el-table-column>
                <el-table-column
                  v-if="bkTableData.modifyTime"
                  prop="modifyTime"
                  show-overflow-tooltip
                  label="入库时间"
                  min-width="70px"
                  align="center"
                >
                </el-table-column>
                <el-table-column
                  v-if="!bkTableData.modifyTime"
                  prop="addTime"
                  show-overflow-tooltip
                  label="入库时间"
                  min-width="70px"
                  align="center"
                >
                </el-table-column>
                <el-table-column
                  prop="version"
                  min-width="80"
                  label="版本"
                  align="center"
                >
                </el-table-column>
                
                <el-table-column
                  show-overflow-tooltip
                  label="操作"
                  align="center"
                >
                  <template slot-scope="scope">
                    <span
                      class="right-add-button"
                      style="display: block"
                      @click="versionView(scope.row)"
                      >【查看版本】</span
                    >
                    <span
                      class="right-add-button"
                      style="display: block"
                      @click="editFile(scope.row)"
                      >【内容编辑】</span
                    >
                    <span class="right-add-button" style="display: block" @click="preview(scope.row,false)">【预览】</span>
                  </template>
                </el-table-column>
              </el-table>
              <!-- 主列表分页 -->
              <div class="pagination-box">
                <el-pagination
                  @size-change="handleSizeChange"
                  @current-change="handleCurrentChange"
                  :current-page="currentPage"
                  :page-sizes="[10, 20, 50, 100]"
                  :page-size="pageSize"
                  layout="total, sizes, prev, pager, next, jumper"
                  :total="totalSize"
                >
                </el-pagination>
              </div>
            </div>
          </div>

          <!-- 资源出库弹窗 -->
          <el-dialog title="资源出库" :visible.sync="outDialog" width="600px">
            <el-form>
              <el-form-item label="任务名称" label-width="80px">
                <el-input
                  type="text"
                  placeholder="请填写出库任务名称"
                ></el-input>
              </el-form-item>
              <el-form-item>
                <el-radio label="2">是否同时导出多媒体源文件</el-radio>
              </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
              <el-button type="primary">确 定</el-button>
              <el-button @click="outDialog = false">取 消</el-button>
            </span>
          </el-dialog>
          <!-- 删除确认弹窗 -->
          <el-dialog
            title="删除问答对"
            :visible.sync="deletePreDialog"
            width="600px"
          >
            <div>确定删除该问答对</div>
            <span slot="footer" class="dialog-footer">
              <el-button type="primary" @click="deleteEntry">确 定</el-button>
              <el-button @click="deletePreDialog = false">取 消</el-button>
            </span>
          </el-dialog>
          <!-- 按条目表出库弹窗 -->
          <el-dialog
            title="按条目表出库"
            :visible.sync="listOutDialog"
            width="600px"
          >
            <el-form>
              <el-form-item label="任务名称" label-width="80px">
                <el-input
                  type="text"
                  placeholder="请填写出库任务名称"
                ></el-input>
              </el-form-item>
              <el-form-item label="条目表" label-width="80px">
                <el-upload>
                  <el-button slot="trigger" size="small" type="primary"
                    >选取文件</el-button
                  >
                  <el-button
                    style="margin-left: 10px"
                    size="small"
                    type="success"
                    hidden
                    >上传到服务器</el-button
                  >
                </el-upload>
                <el-radio label="2">是否同时导出多媒体源文件</el-radio>
              </el-form-item>
            </el-form>
            <el-button style="margin-left: 60px">下载条目列表模板</el-button>
            <span slot="footer" class="dialog-footer">
              <el-button type="primary">确 定</el-button>
              <el-button @click="listOutDialog = false">取 消</el-button>
            </span>
          </el-dialog>
          <!-- 专项内容出库弹窗 -->
          <el-dialog
            title="专项内容出库"
            :visible.sync="specialOutDialog"
            width="600px"
          >
            <el-form>
              <el-form-item label="任务名称" label-width="80px">
                <el-input
                  type="text"
                  placeholder="请填写出库任务名称"
                ></el-input>
              </el-form-item>
            </el-form>
            <div>
              <el-checkbox>全选</el-checkbox>
              <!-- <div style="margin: 15px 0"></div> -->
              <div>
                <el-checkbox>学科分支</el-checkbox>
                <el-checkbox>学科分支</el-checkbox>
                <el-checkbox>学科分支</el-checkbox>
                <el-checkbox>学科分支</el-checkbox>
                <el-checkbox>学科分支</el-checkbox>
              </div>
            </div>
            <span slot="footer" class="dialog-footer">
              <el-button type="primary">确 定</el-button>
              <el-button @click="specialOutDialog = false">取 消</el-button>
            </span>
          </el-dialog>
          <!-- 资源对比弹窗 -->
          <el-dialog
            title="资源对比"
            :visible.sync="compareDialog"
            width="600px"
          >
            <el-upload>
              <el-button slot="trigger" size="small" type="primary"
                >选取文件</el-button
              >
              <el-button
                style="margin-left: 10px"
                size="small"
                type="success"
                hidden
                >上传到服务器</el-button
              >
            </el-upload>
            <el-button style="margin: 30px 0">对比模板下载</el-button>
            <span
              slot="footer"
              class="dialog-footer"
              style="text-align: center"
            >
              <el-button type="primary">开始对比</el-button>
              <el-button @click="compareDialog = false">取 消</el-button>
            </span>
          </el-dialog>
          <!-- 查看日志弹窗 -->
          <el-dialog
            title="资源对比"
            :visible.sync="logViewDialog"
            width="900px"
          >
            <p style="margin-bottom: 20px">
              查看词条日志：<span>菲律宾魔杖</span>
            </p>
            <el-table
              element-loading-text="拼命加载中"
              element-loading-spinner="el-icon-loading"
              style="width: 100%"
              class="maintable"
              border
              :header-cell-style="{ background: '#f8f8f8' }"
            >
              <el-table-column type="index" min-width="50" align="center">
              </el-table-column>
              <el-table-column
                prop="name"
                show-overflow-tooltip
                min-width="80"
                label="名称"
                align="center"
              ></el-table-column>
              <el-table-column
                prop="address"
                min-width="80"
                label="操作类型"
                align="center"
              >
              </el-table-column>
              <el-table-column
                show-overflow-tooltip
                label="操作明细"
                min-width="70px"
                align="center"
              >
              </el-table-column>
              <el-table-column
                show-overflow-tooltip
                label="用户名"
                min-width="70px"
                align="center"
              >
              </el-table-column>
              <el-table-column
                show-overflow-tooltip
                label="时间"
                align="center"
              >
              </el-table-column>
            </el-table>
            <span
              slot="footer"
              class="dialog-footer"
              style="text-align: center"
            >
              <el-button @click="logViewDialog = false">取 消</el-button>
            </span>
          </el-dialog>
          <!-- 查看版本弹窗 -->
          <el-dialog
            title="历史版本"
            :visible.sync="versionDialog"
            width="900px"
          >
            <el-table
              :data="versionListData"
              element-loading-text="拼命加载中"
              element-loading-spinner="el-icon-loading"
              style="width: 100%"
              class="maintable"
              border
              :header-cell-style="{ background: '#f8f8f8' }"
            >
              <el-table-column type="index" min-width="50" align="center">
              </el-table-column>
              <el-table-column
                show-overflow-tooltip
                min-width="80"
                label="条目名称"
                align="center"
                >{{ fileName }}</el-table-column
              >
              <el-table-column
                prop="addUser"
                min-width="80"
                label="提交人"
                align="center"
              >
              </el-table-column>
              <el-table-column
                prop="addTime"
                show-overflow-tooltip
                label="操作时间"
                min-width="70px"
                align="center"
              >
              </el-table-column>
              <el-table-column
                prop="version"
                show-overflow-tooltip
                label="版本号"
                width="80px"
                align="center"
              >
              </el-table-column>
              <el-table-column
                show-overflow-tooltip
                label="操作"
                align="center"
              >
                <template slot-scope="scope">
                  <span
                    class="right-add-button"
                    style="display: block"
                    @click="preview(scope.row,true)"
                    >【预览】</span
                  >
                </template>
              </el-table-column>
            </el-table>
            <div class="pagination-box">
              <el-pagination
                @size-change="handleSizeChange1"
                @current-change="handleCurrentChange1"
                :current-page="currentPage1"
                :page-sizes="[10, 20, 50, 100]"
                :page-size="pageSize1"
                layout="total, sizes, prev, pager, next, jumper"
                :total="totalSize1"
              >
              </el-pagination>
            </div>
            <span
              slot="footer"
              class="dialog-footer"
              style="text-align: center"
            >
              <el-button @click="versionDialog = false">取 消</el-button>
            </span>
          </el-dialog>
          <!-- 编辑问答对弹窗 -->
          <el-dialog
            title="编辑问答对"
            :visible.sync="editDialog"
            width="800px"
            class="editFile"
            id="qaEditFile"
          >
            <el-form
              ref="editFileForm"
              :rules="editFileRules"
              :model="editFileForm"
              label-width="75px"
            >
              <el-form-item label="问题：">
                <el-input
                  v-model="editFileForm.name"
                  placeholder="请输入问题"
                ></el-input>
              </el-form-item>
              <el-form-item label="关键词：">
                <el-input
                  v-model="editFileForm.keywords"
                  placeholder="请输入关键词"
                ></el-input>
              </el-form-item>
              <el-form-item label="首字母：">
                <el-input
                  v-model="editFileForm.firstLetter"
                  placeholder="请输入首字母"
                ></el-input>
              </el-form-item>
              <el-form-item
                label="正文："
                class="editContent"
              >
                <el-input v-model="editFileForm.content" type="textarea" rows="4">
                </el-input>
              </el-form-item>
            </el-form>
            <div class="addResourceBox">
              <el-button type="text" icon="el-icon-plus" size="small"
                @click="getAllMediaData();allMediaDialog = true"  :disabled="this.listInnerCode == ''" >添加资源</el-button
              >
              <el-button type="text" icon="el-icon-plus" size="small"
                @click="deleteMediaData()"  :disabled="this.listInnerCode == ''" >删除资源</el-button
              >
               <!-- qa媒体文件列表 -->
            <div class="mediaManageBox">
              <el-table
                :data="qaMediaData"
                v-loading="qaMediaTableLoading"
                element-loading-text="拼命加载中"
                element-loading-spinner="el-icon-loading"
                element-loading-customClass="loadingStyles"
                style="width: 100%"
                class="maintable"
                border
                :header-cell-style="{ background: '#f8f8f8' }"
                @selection-change="qaMediaHandleTableSelectionChange"
              >
                <el-table-column
                  type="selection"
                  min-width="55"
                  align="center"
                ></el-table-column>
                <el-table-column
                  prop="title"
                  show-overflow-tooltip
                  min-width="80"
                  label="资源标题"
                  align="center"
                ></el-table-column>
                <el-table-column
                  prop="subjectInfo.name"
                  min-width="80"
                  label="分支"
                  align="center"
                >
                </el-table-column>
                <el-table-column
                  prop="type"
                  show-overflow-tooltip
                  label="类型"
                  min-width="70px"
                  align="center"
                >
                  <template slot-scope="scope">
                    <span effect="dark" v-if="scope.row.type == 1">图片</span>
                    <span effect="dark" v-if="scope.row.type == 2">视频</span>
                    <span effect="dark" v-if="scope.row.type == 3">音频</span>
                    <span effect="dark" v-if="scope.row.type == 4">3D</span>
                  </template>
                </el-table-column>
              </el-table>
              <!-- qa多媒体列表分页 -->
              <!-- <div class="pagination-box">
                <el-pagination
                  @size-change="qaMediaHandleSizeChange"
                  @current-change="qaMediaHandleCurrentChange"
                  :current-page="qaMediaCurrentPage"
                  :page-sizes="[10, 20, 50, 100]"
                  :page-size="qaMediaPageSize"
                  layout="total, sizes, prev, pager, next, jumper"
                  :total="qaMediaTotalSize"
                >
                </el-pagination>
              </div> -->
            </div>
            </div>
            <span
              slot="footer"
              class="dialog-footer"
              style="text-align: center"
            >
              <el-button type="primary" @click="bkEdit(editFileForm)"
                >确 定
              </el-button>
              <el-button @click="editDialog = false">取 消</el-button>
            </span>
          </el-dialog>
          <!-- 获取所有多媒体资源弹窗 -->
            <el-dialog
            title="多媒体资源添加"
            :visible.sync="allMediaDialog"
            width="1000px"
            class="allMediaDialog"
          >
            <div id="mediaSearchBox">
              <el-form
                label-width="120px"
                ref="mediaSearchFileForm"
                :model="mediaSearchFileForm"
              >
                <el-form-item label="资源名称：">
                  <el-input
                    v-model="mediaSearchFileForm.title"
                    placeholder="请输入资源名称"
                  ></el-input>
                </el-form-item>
                <el-form-item label="类型：">
                  <el-select
                    placeholder="请选择类型"
                    v-model="mediaSearchFileForm.type"
                    clearable
                  >
                    <el-option value="1" label="图片"> </el-option>
                    <el-option value="2" label="视频"> </el-option>
                    <el-option value="3" label="音频"> </el-option>
                    <el-option value="4" label="3D"> </el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="资源状态：">
                  <el-select v-model="mediaSearchFileForm.status" clearable>
                    <el-option value="10" label="下架"> </el-option>
                    <el-option value="20" label="上架"> </el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="是否存在原图：">
                  <el-select v-model="mediaSearchFileForm.isOriginal" clearable>
                    <el-option value="10" label="否"> </el-option>
                    <el-option value="20" label="是"> </el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label-width="0px">
                  <el-button
                    type="primary"
                    size="mini"
                    icon="el-icon-search"
                    @click="
                      mediaCurrentPage = 1;
                      mediaOnSearch();
                    "
                    >查询</el-button
                  >
                </el-form-item>
              </el-form>
            </div>
             <!-- 全部媒体文件列表 -->
            <div class="mediaManageBox">
              <el-table
                :data="allMediaData"
                v-loading="mediaTableLoading"
                element-loading-text="拼命加载中"
                element-loading-spinner="el-icon-loading"
                element-loading-customClass="loadingStyles"
                style="width: 100%"
                class="maintable"
                border
                :header-cell-style="{ background: '#f8f8f8' }"
                @selection-change="mediaHandleTableSelectionChange"
              >
                <el-table-column
                  type="selection"
                  min-width="55"
                  align="center"
                ></el-table-column>
                <el-table-column
                  prop="logoPath"
                  min-width="50"
                  align="center"
                  label="封面图"
                >
                  <template slot-scope="scope">
                    <img
                      :src="scope.row.logoPath"
                      style="width: 100%; max-height: 90px"
                    />
                  </template>
                </el-table-column>
                <el-table-column
                  prop="title"
                  show-overflow-tooltip
                  min-width="80"
                  label="资源标题"
                  align="center"
                ></el-table-column>
                <el-table-column
                  prop="subjectInfo.name"
                  min-width="80"
                  label="分支"
                  align="center"
                >
                </el-table-column>
                <el-table-column
                  prop="status"
                  show-overflow-tooltip
                  label="状态"
                  min-width="70px"
                  align="center"
                >
                  <template slot-scope="scope">
                    <span effect="dark" v-if="scope.row.status == 20"
                      >已上架</span
                    >
                    <span effect="dark" v-if="scope.row.status == 10"
                      >未上架</span
                    >
                  </template>
                </el-table-column>
                <el-table-column
                  prop="type"
                  show-overflow-tooltip
                  label="类型"
                  min-width="70px"
                  align="center"
                >
                  <template slot-scope="scope">
                    <span effect="dark" v-if="scope.row.type == 1">图片</span>
                    <span effect="dark" v-if="scope.row.type == 2">视频</span>
                    <span effect="dark" v-if="scope.row.type == 3">音频</span>
                    <span effect="dark" v-if="scope.row.type == 4">3D</span>
                  </template>
                </el-table-column>
                <el-table-column
                  prop="isCopyright"
                  show-overflow-tooltip
                  label="是否有版权"
                  min-width="70px"
                  align="center"
                >
                  <template slot-scope="scope">
                    <span effect="dark" v-if="scope.row.isCopyright == 1"
                      >否</span
                    >
                    <span effect="dark" v-if="scope.row.isCopyright == 2"
                      >是</span
                    >
                  </template>
                </el-table-column>
                <el-table-column
                  prop="isRemove"
                  show-overflow-tooltip
                  label="是否已被删除"
                  min-width="70px"
                  align="center"
                >
                  <template slot-scope="scope">
                    <span
                      effect="dark"
                      v-if="
                        scope.row.isRemove == 10 || scope.row.isRemove == null
                      "
                      >否</span
                    >
                    <span effect="dark" v-if="scope.row.isRemove == 20"
                      >是</span
                    >
                  </template>
                </el-table-column>
              </el-table>
              <!-- 多媒体列表分页 -->
              <div class="pagination-box">
                <el-pagination
                  @size-change="mediaHandleSizeChange"
                  @current-change="mediaHandleCurrentChange"
                  :current-page="mediaCurrentPage"
                  :page-sizes="[10, 20, 50, 100]"
                  :page-size="mediaPageSize"
                  layout="total, sizes, prev, pager, next, jumper"
                  :total="mediaTotalSize"
                >
                </el-pagination>
              </div>
            </div>
            <span
              slot="footer"
              class="dialog-footer"
              style="text-align: center"
            >
              <el-button type="primary" @click="mediaItemToQa()"
                >确 定
              </el-button>
              <el-button @click="allMediaDialog = false">取 消</el-button>
            </span>
          </el-dialog>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Menu from "../../menu/menu.vue";
import LeftSideBar from "../../menu/leftSideBar.vue";
import $ from "jquery";
import cookies from "vue-cookies";
export default {
  data: function () {
    return {
      listData: [],
      getAuthority: {},
      versionListData: [],
      currentPage: 1,
      pageSize: 10,
      totalSize: 50,
      mediaCurrentPage: 1,
      mediaPageSize: 10,
      mediaTotalSize: 50,
      qaMediaCurrentPage: 1,
      qaMediaPageSize: 10,
      qaMediaTotalSize: 50,
      currentPage1: 1,
      pageSize1: 10,
      totalSize1: 50,
      dataText: "",
      optionData: [],
      bkTableData: [],
      treeData: [],
      treeNode_had: [],
      treeResolve_had: [],
      multipleSelectionTable: [],
      mediaMultipleSelectionTable: [],
      qaMediaMultipleSelectionTable: [],
      sourceList: [],
      searchFileForm: {
        name: "",
        sourceId: "",
        status: "",
      },
      sortContentForm: {},
      treeSearchContent: "",
      listInnerCode: "",
      opentree: true,
      fileName: "",
      editFileForm: {
        id: "",
        version: "",
        name: "",
        firstLetter: "",
        content: "",
        keywords:"",
      },
      props: {
        label: "name",
        children: "children",
        isLeaf: "leaf",
      },
      mediaTableLoading:false,
      qaMediaTableLoading:false,
      allMediaData:[],
      mediaSearchFileForm:{},
      qaMediaData:[],
      versionId:"",
      // 弹窗组
      outDialog: false,
      deletePreDialog: false,
      listOutDialog: false,
      specialOutDialog: false,
      compareDialog: false,
      logViewDialog: false,
      versionDialog: false,
      editDialog: false,
      allMediaDialog:false,
      // 规则
      editFileRules: {},
    };
  },
  components: {
    Menu,
    LeftSideBar,
  },
  mounted() {
    // 统一验证token
    var currentToken = cookies.get("token");
    $.ajaxSetup({
      headers: {
        AuthorizationToken: currentToken,
      },
      complete: function (xhr) {
        if (xhr.responseJSON.code == 401) {
          window.location.href = "/";
        }
      },
    });
    this.searchParam();
    this.getSourceList();
  },
  watch: {
    treeSearchContent(val) {
      this.$refs.tree.filter(val);
    },
  },
  methods: {
    // 搜索
    onSearch() {
      this.searchParam();
    },
    // 多媒体列表搜索
    mediaOnSearch () {
      this.getAllMediaData();
    },
    // 加载数据
    searchParam() {
      let that = this;
      let params = Object.assign({}, this.searchFileForm);
      params.innerCode = this.listInnerCode;
      params.type = 140;
      params.size = this.pageSize;
      params.page = this.currentPage;
      
      $.each(params, function(key, value) {
          if (value === null || value === undefined || value === '') {
              // 这里可以添加代码来处理空值，例如删除该属性
              delete params[key];
          }
      });
      $.ajax({
        type: "GET",
        dataType: "json",
        url: "/zyk/c/qa/qaInfo/list",
        data: params,
        // contentType: "application/json;charset=utf-8",
        // contentType: "application/json;charset=utf-8",
        success: function (response) {
          if (response.code == 200) {
            that.optionData = response.obj.list;
            if (response.obj.list && response.obj.list.length == 0) {
              that.dataText = "暂无数据";
            }
            that.totalSize = response.obj.total;
            that.bkTableData = response.obj.list;
            that.currentPage = response.obj.pageNum;
          } else {
            that.$message({
              message: response.msg,
              duration: 0,
              showClose: true,
              type: "error",
              offset: 100,
            });
          }
        },
        error: function (data) {
          console.log(data);
        },
      });
    },
    // 树形结构加载
    loadNode(node, resolve) {
      let that = this;
      this.getAuthority = node;
      $.ajax({
        url: "/zyk/c/subject/subjectInfo/list?size=1000&page=1",
        type: "GET",
        data: { type: 140 },
        //contentType: 'application/json;charset=utf-8',
        dataType: "json",
        error: function (xhr) {
          if (xhr.status == 401) {
            window.location.reload();
          }
        },
        success: function (data) {
          if (node.level == 0) {
            return resolve([{ name: "百科数据资源库", id: "-1" }]);
          } else if (node.level == 1) {
            this.treeNode_had = node;
            that.dataList = data.obj.list;
            return resolve(that.dataList);
          } else {
            $.ajax({
              url: "/zyk/c/subject/subjectInfo/list?size=1000&page=1",
              type: "GET",
              //contentType: 'application/json;charset=utf-8',
              data: { id: node.data.id },
              dataType: "json",
              error: function (xhr) {
                if (xhr.status == 401) {
                  window.location.reload();
                }
              },
              success: function (data) {
                return resolve(data.obj.list);
              },
            });
          }
        },
      });
    },
    // 点击树
    listClick(node) {
      let that = this;
      that.getAuthority = node;

      if (node.id == -1) {
        that.sortContentForm = {
          id: "-1",
          name: "百科数据资源库",
        };
      } else {
        that.listInnerCode = node.innerCode;
        that.searchParam();
      }
    },
    // 编辑、上下架前确认
    preCheck(current) {
      let that = this;
      let ids = this.multipleSelectionTable.map((item) => {
        return item.id;
      });
      let flagArr = [];
      let flag = true;
      let statusArr = this.multipleSelectionTable.map((item) => {
        return item.status;
      });
      if (this.multipleSelectionTable.length == 0) {
        this.$message({
          message: "请选中具体的资源",
          duration: 0,
          showClose: true,
          type: "error",
          offset: 100,
        });
      } else if (current == "toDown") {
        $.each(statusArr, function (index, element) {
          if (element === 20) {
            flagArr.push(true);
          } else {
            flagArr.push(false);
          }
        });
        flag = flagArr.every(function (value) {
          return value;
        });
        if (!flag) {
          that.$message({
            message: "资源下架状态，不可重复下架",
            duration: 0,
            showClose: true,
            type: "error",
            offset: 100,
          });
        } else {
          $.ajax({
            type: "POST",
            dataType: "json",
            data: {
              ids: ids.toString(),
              toStatus: 10,
            },
            url: "/zyk/qa/putUpdown",
            success: function (response) {
              if (response.code == 200) {
                that.searchParam();
                that.$message({
                  message: "资源已下架",
                  duration: 0,
                  showClose: true,
                  type: "success",
                  offset: 100,
                });
              } else {
                that.$message({
                  message: response.msg,
                  duration: 0,
                  showClose: true,
                  type: "error",
                  offset: 100,
                });
              }
            },
            error: function (data) {
              console.log(data);
            },
          });
        }
      } else if (current == "toUP") {
        $.each(statusArr, function (index, element) {
          if (element === 10) {
            flagArr.push(true);
          } else {
            flagArr.push(false);
          }
        });
        flag = flagArr.every(function (value) {
          return value;
        });
        if (!flag) {
          that.$message({
            message: "资源上架状态，不可重复上架",
            duration: 0,
            showClose: true,
            type: "error",
            offset: 100,
          });
        } else {
          $.ajax({
            type: "POST",
            dataType: "json",
            data: {
              ids: ids.toString(),
              toStatus: 20,
            },
            url: "/zyk/qa/putUpdown",
            success: function (response) {
              if (response.code == 200) {
                that.searchParam();
                that.$message({
                  message: "资源已上架",
                  duration: 0,
                  showClose: true,
                  type: "success",
                  offset: 100,
                });
              } else {
                that.$message({
                  message: response.msg,
                  duration: 0,
                  showClose: true,
                  type: "error",
                  offset: 100,
                });
              }
            },
            error: function (data) {
              console.log(data);
            },
          });
        }
      } else if (current == "toDelete") {
        $.each(statusArr, function (index, element) {
          if (element === 10) {
            flagArr.push(true);
          } else {
            flagArr.push(false);
          }
        });
        flag = flagArr.every(function (value) {
          return value;
        });
        if (!flag) {
          that.$message({
            message: "资源上架状态，请下架后再删除",
            duration: 0,
            showClose: true,
            type: "error",
            offset: 100,
          });
        } else {
          this.deletePreDialog = true;
        }
      }
    },
    // 编辑确认
    bkEdit(formName) {
      let that = this;
      formName.resourceIds = this.qaMediaData.map((item) => {
        return item.id;
      }).toString();
      $.ajax({
        url: "/zyk/c/qa/qaInfo/update",
        type: "POST",
        dataType: "json",
        data: formName,
        error: function (xhr) {
          if (xhr.status == 401) {
            window.location.reload();
          }
        },
        success: function (data) {
          if (data.code == 200) {
            that.$message({
              message: "成功",
              duration: 2000,
              showClose: true,
              type: "success",
              offset: 100,
            });
            that.searchParam();
            that.editDialog = false;
          } else {
            that.$message({
              message: data.msg,
              duration: 0,
              showClose: true,
              type: "error",
              offset: 100,
            });
          }
        },
      });
    },
    SourceOut() {
      this.outDialog = true;
    },
    deletePre() {
      this.deletePreDialog = true;
    },
    listOut() {
      this.listOutDialog = true;
    },
    specialOut() {
      this.specialOutDialog = true;
    },
    sourceCompare() {
      this.compareDialog = true;
    },
    logView() {
      this.logViewDialog = true;
    },
    versionView(row) {
      this.versionDialog = true;
      let that = this;
      let params = {};
      params.qaId = row.id;
      params.size = this.pageSize;
      params.page = this.currentPage;
      this.versionId = row.id;
      $.ajax({
        type: "GET",
        dataType: "json",
        url: "/zyk/c/qa/vQaInfo/list",
        data: params,
        contentType: "application/json;charset=utf-8",
        success: function (response) {
          if (response.code == 200) {
            that.optionData = response.obj.list;
            if (response.obj && response.obj.length == 0) {
              that.dataText = "暂无数据";
            }
            that.totalSize1 = response.obj.total;
            that.versionListData = response.obj.list;
            that.fileName = row.name;
            that.currentPage1 = response.obj.pageNum;
          } else {
            that.$message({
              message: response.msg,
              duration: 0,
              showClose: true,
              type: "error",
              offset: 100,
            });
          }
        },
        error: function (data) {
          console.log(data);
        },
      });
    },
    // 编辑源文件
    editFile(row) {
      console.log(row);
      this.editFileForm = {
        id: row.id,
        name: row.name,
        firstLetter: row.firstLetter,
        content: row.content,
        keywords:row.keywords,
      };
      this.qaMediaData = row.resourceInfos
      this.editDialog = true;
    },
    // 选择表格某一行
    handleTableSelectionChange(val) {
      this.multipleSelectionTable = val;
    },
    // 多媒体资源选择表格某一行
    mediaHandleTableSelectionChange(val) {
      this.mediaMultipleSelectionTable = val;
    },
    // 多媒体资源选择表格某一行
    qaMediaHandleTableSelectionChange(val) {
      this.qaMediaMultipleSelectionTable = val;
    },
    // 左侧树搜索
    treeSearch(value, data) {
      if (!value) return true;
      console.log(value, data);
      return data.name.indexOf(value) !== -1;
    },
    // 分页
    handleSizeChange(val) {
      this.pageSize = val;
      this.searchParam();
    },
    handleCurrentChange(val) {
      this.currentPage = val;
      this.searchParam();
    },
    // 多媒体资源分页
    mediaHandleSizeChange(val) {
      this.mediaPageSize = val;
      this.getAllMediaData();
    },
    mediaHandleCurrentChange(val) {
      this.mediaCurrentPage = val;
      this.getAllMediaData();
    },
    // 多媒体资源分页
    qaMediaHandleSizeChange(val) {
      this.mediaPageSize = val;
      this.getAllMediaData();
    },
    qaMediaHandleCurrentChange(val) {
      this.mediaCurrentPage = val;
      this.getAllMediaData();
    },
    // 分页
    handleSizeChange1(val) {
      this.pageSize1 = val;
      this.versionView();
    },
    handleCurrentChange1(val) {
      this.currentPage1 = val;
      this.versionView();
    },
    // 预览页面跳转
    preview(row,versionFlag) {
      var downloadA = document.createElement("a");
      if (versionFlag) {
         downloadA.href =
        "/qaPreview?id=" + this.versionId + "&version=" + row.version;
      }else{
        downloadA.href = "/qaPreview?id=" + row.id;
      }
      downloadA.target = "_blank";
      downloadA.click();
    },
    // 获取来源list
    getSourceList() {
      let that = this;
      $.ajax({
        type: "GET",
        dataType: "json",
        data: {
          page: 1,
          size: 1000,
        },
        url: "/zyk/c/source/sourceInfo/list",
        success: function (response) {
          if (response.code == 200) {
            that.optionData = response.obj.list;
            if (response.obj && response.obj.list.length == 0) {
              that.dataText = "暂无数据";
            }
            that.sourceList = response.obj.list;
          } else {
            that.$message({
              message: response.msg,
              duration: 0,
              showClose: true,
              type: "error",
              offset: 100,
            });
          }
        },
        error: function (data) {
          console.log(data);
        },
      });
    },
    // 删除条目
    deleteEntry() {
      let that = this;
      that.deleteIds = this.multipleSelectionTable.map((item) => {
        return item.id;
      });

      $.ajax({
        url: "/zyk/c/qa/qaInfo/remove",
        type: "POST",
        //contentType: 'application/json;charset=utf-8',
        dataType: "json",
        data: { ids: this.deleteIds.toString() },
        error: function (xhr) {
          if (xhr.status == 401) {
            window.location.reload();
          }
        },
        success: function (data) {
          if (data.code == 200) {
            that.$message({
              message: "删除成功",
              duration: 2000,
              showClose: true,
              type: "success",
              offset: 100,
            });
            that.deletePreDialog = false;
            that.searchParam();
          } else {
            that.$message({
              message: data.msg,
              duration: 0,
              showClose: true,
              type: "error",
              offset: 100,
            });
          }
        },
      });
    },

    // 获取多媒体资源
    getAllMediaData(){
      let that = this;
      let params = Object.assign({}, this.mediaSearchFileForm);
      params.size = this.mediaPageSize;
      params.page = this.mediaCurrentPage;
      that.mediaTableLoading = true;
      $.each(params, function(key, value) {
          if (value === null || value === undefined || value === '') {
              // 这里可以添加代码来处理空值，例如删除该属性
              delete params[key];
          }
      });
      $.ajax({
        type: "GET",
        dataType: "json",
        url: "/zyk/c/resource/resourceInfo/list",
        data: params,
        // contentType: "application/json;charset=utf-8",
        success: function (response) {
          if (response.code == 200) {
            that.allMediaData = response.obj.list;
            if (response.obj.list && response.obj.list.length == 0) {
              that.dataText = "暂无数据";
            }
            that.mediaTableLoading = false;
            that.mediaTotalSize = response.obj.total;
            that.bkTableData = response.obj.list;
            that.mediaCurrentPage = response.obj.pageNum;
          } else {
            that.$message({
              message: response.msg,
              duration: 0,
              showClose: true,
              type: "error",
              offset: 100,
            });
          }
        },
        error: function (data) {
          console.log(data);
        },
      });
    },
    // 删除多媒体资源
    deleteMediaData(){
      console.log(this.qaMediaMultipleSelectionTable);
      
      let ids = this.qaMediaMultipleSelectionTable.map((item) => {
        return item.id;
      });
      console.log(ids);
      
      this.qaMediaData = this.qaMediaData.filter((item) => {
        if(!ids.includes(item.id)){
          return item
        }
      })
    },
    mediaItemToQa(){
      var that = this
      this.mediaMultipleSelectionTable.forEach(function (item) {
        that.qaMediaData.push({
          id: item.id,
          title:item.title,
          type: item.type,
          subBranch:item.subjectInfo.subBranch
        })
      })
      this.allMediaDialog = false;
    }
  },
};
</script>

<style>
#sortContent {
  clear: both;
  margin-top: -8px;
  margin-left: 170px;
}

.rightBox {
  float: right;
  width: calc(100% - 250px);
}
.information {
  width: 100%;
}

.el-dialog .el-form {
  padding: 10px 50px;
}

.reorderPreDialog {
  text-align: center;
}

.reorderPreDialog .el-input {
  display: inline;
}
.reorderPreDialog input {
  width: 100px;
}
.reorderPreDialog .red {
  color: red;
}

.editFile .el-form-item {
  float: left;
  width: 50% !important;
}
.editFile .editContent {
  width: 100% !important;
}

.editFile .el-form {
  padding: 0 !important;
  height: 500px;
}

.mainBox {
  overflow: auto;
  border: 1px solid #dcdfe6;
  border-radius: 10px;
}
.mainBox::after,
.mainBox .leftBoxDialog {
  content: "";
  display: inline-block;
  clear: both;
}
.mainBox .leftBoxDialog {
  width: 30%;
  float: left;
  border-right: 1px solid #dcdfe6;
}
.mainBox .leftBoxDialog input {
  width: 100%;
  height: 30px;
  font-size: 14px;
}
.mainBox .leftBoxDialog .el-input,
.mainBox .leftBoxDialog .el-select {
  float: left;
}
.mainBox .leftBoxDialog .leftUp {
  border-bottom: 1px solid #50b58d;
  padding: 10px 0 10px 10px;
}

.mainBox .leftBoxDialog .el-input__icon {
  line-height: 30px;
}
.mainBox .rightBoxDialog {
  width: 69%;
  float: left;
}

.mainBox .rightBoxDialog .dialogBtnBox {
  border-bottom: 1px solid #50b58d;
  padding: 8px 0 8px 10px;
}

.mainBox .rightBoxDialog .el-form {
  padding: 10px 20px;
}

.mainBox .rightBoxDialog .el-form .el-textarea textarea {
  height: 300px;
}

#searchBox {
  padding-bottom: 22px;
}

#searchBox .el-select {
  width: 202px;
}

#searchBox .el-form-item {
  margin-bottom: 0;
}

#searchBox .el-form button.el-button {
  margin-left: 20px !important;
}

#searchBox .el-date-editor .el-range__icon {
  line-height: 25px;
}

#searchBox.el-date-editor .el-range-separator {
  line-height: 23px;
}

#qaEditFile .el-dialog{
  margin-top: 15vh !important;
}

#qaEditFile .el-dialog .el-form{
  height: auto;
}

#qaEditFile .el-form-item{
  width: 100% !important;
}

#mediaSearchBox .el-form-item{
  width: 50%;
}

#mediaSearchBox .el-form-item .el-select{
  width: 100% ;
}

#mediaSearchBox .el-form{
  padding: 10px 0;
}
</style>